import React, { useState, useEffect } from 'react';
//import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form } from 'react-bootstrap';

const ChoiceModal = ({ list1Choices, list2Choices, onSave}) => {
  const [show, setShow] = useState(false);
  const [selectedChoices, setSelectedChoices] = useState({
    list1: {},
    list2: {}
  });

  useEffect(() => {
    // Initialize all checkboxes as checked
    const initialList1 = list1Choices.reduce((acc, choice) => {
      acc[choice.id] = true;
      return acc;
    }, {});
    
    const initialList2 = list2Choices.reduce((acc, choice) => {
      acc[choice.id] = true;
      return acc;
    }, {});

    setSelectedChoices({
      list1: { ...initialList1, other: true },
      list2: { ...initialList2, other: true }
    });
  }, [list1Choices, list2Choices]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCheckboxChange = (listName, id) => {
    setSelectedChoices(prev => ({
      ...prev,
      [listName]: {
        ...prev[listName],
        [id]: !prev[listName][id]
      }
    }));
  };

  const isValidSelection = () => {
    const list1Valid = Object.values(selectedChoices.list1).some(Boolean);
    const list2Valid = Object.values(selectedChoices.list2).some(Boolean);
    return list1Valid && list2Valid;
  };

  const handleModalSave = () => {
    if (!isValidSelection()) {
      alert("Please select at least one option from each list.");
      return;
    }

    const selectedList1 = list1Choices
      .filter(choice => selectedChoices.list1[choice.id])
      .map(choice => choice.label);
    
    const selectedList2 = list2Choices
      .filter(choice => selectedChoices.list2[choice.id])
      .map(choice => choice.label);
    
    const otherSelected1 = selectedChoices.list1.other || false;
    const otherSelected2 = selectedChoices.list2.other || false;
    
    onSave({ 
      selectedList1, 
      selectedList2, 
      otherSelected1,
      otherSelected2
    });
    handleClose();
  };

  const renderChoices = (choices, listName) => (
    <Form>
      {choices.map(choice => (
        <Form.Check 
          key={choice.id}
          type="checkbox"
          id={`${listName}-${choice.id}`}
          label={choice.label}
          checked={selectedChoices[listName][choice.id]}
          onChange={() => handleCheckboxChange(listName, choice.id)}
        />
      ))}
      <Form.Check 
        type="checkbox"
        id={`${listName}-other`}
        label="Other"
        checked={selectedChoices[listName].other}
        onChange={() => handleCheckboxChange(listName, 'other')}
      />
    </Form>
  );

  return (
    <>
      <Button id="openWordListModalButton" variant="outline-secondary" size="sm" onClick={handleShow}>
        Word Lists
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Your Choices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <h5>Levels</h5>
              {renderChoices(list1Choices, 'list1')}
            </div>
            <div className="col-md-6">
              <h5>Categories</h5>
              {renderChoices(list2Choices, 'list2')}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" className="custom-primary-button" onClick={handleModalSave} disabled={!isValidSelection()}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChoiceModal;